import { Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { TextBold, TextSemiBold } from 'UiKit/typography';
import { GIVEAWAY_FORM_DRAFT_KEY } from 'View/brief-live/section/giveaway-form/const';
import { Condition } from 'Component/others';
import ButtonOutline from 'UiKit/button/buttonOutline';
import ButtonSolid from 'UiKit/button/buttonSolid';

import styles from './styles.module.css';

const Head = ({ id, isValid, t }) => {
  const isCreate = !id;
  const navigate = useNavigate();

  return (
    <Box className={styles['head__container']}>
      <TextBold className={styles['head__text-title']}>
        <Condition children={t('formGiveaway.createTitle')} statement={isCreate} fallback={t('formGiveaway.editTitle')} />
      </TextBold>
      <Flex gap={'8px'}>
        <ButtonOutline height={'34px'} type="button" borderColor="var(--color-semantic-black)" onClick={() => { sessionStorage.removeItem(GIVEAWAY_FORM_DRAFT_KEY); navigate('/brief-live?tab=giveaway'); }}>
          <TextSemiBold className={styles['head__text--button-cancel']}>
            <Condition children={t('formGiveaway.cancelButton')} statement={isCreate} fallback={t('formGiveaway.cancelButton')} />
          </TextSemiBold>
        </ButtonOutline>
        <Condition
          statement={isCreate}
          children={
            <ButtonSolid height={'34px'} type="submit" isDisabled={!isValid}>
              {t('formGiveaway.saveButton')}
            </ButtonSolid>
          }
        />
      </Flex>
    </Box>
  );
};

export default Head;
